import { render, staticRenderFns } from "./media_rejection_poup.vue?vue&type=template&id=a731f2e4&scoped=true"
import script from "./media_rejection_poup.vue?vue&type=script&lang=js"
export * from "./media_rejection_poup.vue?vue&type=script&lang=js"
import style0 from "./media_rejection_poup.vue?vue&type=style&index=0&id=a731f2e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a731f2e4",
  null
  
)

export default component.exports